import React from "react";
import AddImputaForm from "./AddImputaForm";

const AddImputa = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Imputación"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddImputaForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddImputa;
